import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

export const vuexPersist = new VuexPersist({
  storage: window.localStorage
})

const getDefaultState = () => {
  return {
    resetData: false,
    resetDisable: false,
    errors: [],
    errorAlert: false,
    rules: {
      required: (value:any) => !!value || value === 0 || 'Required.',
      notNegative: (value:number) => value >= 0 || 'No negative values.'
    },
    scenarios: [],
    activeTool: null,
    simplePasture1: null,
    simplePasture2: null,
    simplePasture3: null,
    simplePasture4: null,
    seasonalPasture1: null,
    seasonalPasture2: null,
    seasonalPasture3: null,
    seasonalPasture4: null,
    otherTools1: null,
    otherTools2: null,
    otherTools3: null,
    otherTools4: null
  }
}

const state = getDefaultState()

export default new Vuex.Store({
  state: state,
  mutations: {
    addScenario (state:any, scenario) {
      state.scenarios.push(scenario)
      // console.log('Scenarios', state.scenarios)
    },
    updateScenario (state, updatedState) {
      state.scenarios = updatedState
    },
    resetState (state:any) {
      const scenarios = JSON.parse(window.localStorage.vuex).scenarios
      Object.assign(state, getDefaultState())
      state.scenarios = scenarios
    },
    resetDisable (state:any, disable) {
      state.resetDisable = disable
    },
    activeTool (state, updatedState) {
      state.activeTool = updatedState
    },
    simplePasture1 (state, updatedState) {
      state.simplePasture1 = updatedState
    },
    simplePasture2 (state, updatedState) {
      state.simplePasture2 = updatedState
    },
    simplePasture3 (state, updatedState) {
      state.simplePasture3 = updatedState
    },
    simplePasture4 (state, updatedState) {
      state.simplePasture4 = updatedState
    },
    seasonalPasture1 (state, updatedState) {
      state.seasonalPasture1 = updatedState
    },
    seasonalPasture2 (state, updatedState) {
      state.seasonalPasture2 = updatedState
    },
    seasonalPasture3 (state, updatedState) {
      state.seasonalPasture3 = updatedState
    },
    seasonalPasture4 (state, updatedState) {
      state.seasonalPasture4 = updatedState
    },
    otherTools1 (state, updatedState) {
      state.otherTools1 = updatedState
    },
    otherTools2 (state, updatedState) {
      state.otherTools2 = updatedState
    },
    otherTools3 (state, updatedState) {
      state.otherTools3 = updatedState
    },
    otherTools4 (state, updatedState) {
      state.otherTools4 = updatedState
    }
  },
  actions: {
    addScenario({ commit }, scenario) {
      commit('addScenario', scenario)
    },
    updateScenario ({ commit }, updatedState) {
      commit('updateScenario', updatedState)
    },
    resetState ({ commit }) {
      commit('resetState')
    },
    resetDisable ({ commit }, disable) {
      commit('resetDisable', disable)
    },
    updateActiveTool ({ commit }, updatedState) {
      commit('activeTool', updatedState)
    },
    updateSimplePasture1 ({ commit }, updatedState) {
      commit('simplePasture1', updatedState)
    },
    updateSimplePasture2 ({ commit }, updatedState) {
      commit('simplePasture2', updatedState)
    },
    updateSimplePasture3 ({ commit }, updatedState) {
      commit('simplePasture3', updatedState)
    },
    updateSimplePasture4 ({ commit }, updatedState) {
      commit('simplePasture4', updatedState)
    },
    updateSeasonalPasture1 ({ commit }, updatedState) {
      commit('seasonalPasture1', updatedState)
    },
    updateSeasonalPasture2 ({ commit }, updatedState) {
      commit('seasonalPasture2', updatedState)
    },
    updateSeasonalPasture3 ({ commit }, updatedState) {
      commit('seasonalPasture3', updatedState)
    },
    updateSeasonalPasture4 ({ commit }, updatedState) {
      commit('seasonalPasture4', updatedState)
    },
    updateOtherTools1 ({ commit }, updatedState) {
      commit('otherTools1', updatedState)
    },
    updateOtherTools2 ({ commit }, updatedState) {
      commit('otherTools2', updatedState)
    },
    updateOtherTools3 ({ commit }, updatedState) {
      commit('otherTools3', updatedState)
    },
    updateOtherTools4 ({ commit }, updatedState) {
      commit('otherTools4', updatedState)
    }
  },
  plugins: [vuexPersist.plugin]
})
